module.exports = __webpack_public_path__ + "static/media/logo.f4674cfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/home/logo.png
// module id = 341
// module chunks = 0